export const initialValues = {
  hoursSettings: {
    monday: {
      timings: [
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
      ],
      open: false,
    },
    tuesday: {
      timings: [
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
      ],
      open: false,
    },
    wednesday: {
      timings: [
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
      ],
      open: false,
    },
    thursday: {
      timings: [
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
      ],
      open: false,
    },
    friday: {
      timings: [
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
      ],
      open: false,
    },
    saturday: {
      timings: [
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
      ],
      open: false,
    },
    sunday: {
      timings: [
        {
          timeEnd: { hours: '01', minutes: '00', timeZone: 'am' },
          timeStart: { hours: '01', minutes: '00', timeZone: 'am' },
        },
      ],
      open: false,
    },
  },
};

export type FormValues = typeof initialValues;
